import Footer from "../../components/Footer/Footer";
import NavBar from "../../components/NavBar/NavBar";
import BannerDevolve from "./components/BannerDevolve/BannerDevolve";
import CashBackGuide from "./components/CashbackGuide/CashbackGuide";
import CashbackIntro from "./components/CashbackIntro/CashbackIntro";
import CashBackProcess from "./components/CashbackPorcess/CashbackProcess";
import FaqSection from "./components/Faq/FaqSection";
import PartnerStores from "./components/LojasParceiras/LojasParceiras";
const MeuCupomDevolve = () => {
    return (
        <>
            <NavBar />
            <BannerDevolve/>
            <CashbackIntro/>
            <CashBackProcess/>
            <CashBackGuide/>
            <FaqSection/>
            <PartnerStores/>
            <Footer/>
        </>
    )
}
export default MeuCupomDevolve;